import keyMirror from 'utils/keyMirror';

/**
 * @constant {Object} BankStatementsConstants
 * @memberof BankStatements
 */
export const BankStatementsConstants = keyMirror({
  SET_DATA_VERSION: undefined,
  GET_STATEMENTS: undefined,
  PROCESS_STATEMENT: undefined,
});
